import React, { useState } from "react";
import { Plus } from "react-feather";
import BlockChart from "./block/BlockChart";
import AddBlockModal from "./block/AddBlockModal";
import BlockTable from "./block/BlockTable";

function Block() {
  const [showModal, setShowModal] = useState(false);
  const [refetch, setRefetch] = useState(false);
  const Modaltoggle = () => setShowModal(!showModal);

  return (
    <>
      <BlockChart />
      <div className="container">
        <div className="d-flex justify-content-between mb-3 mt-3 align-items-center">
          <h5>Block Details</h5>
          <AddBlockModal
            showModal={showModal}
            Modaltoggle={Modaltoggle}
            setShowModal={setShowModal}
            setRefetch={setRefetch}
          />
          <button
            onClick={Modaltoggle}
            style={{ border: "none", borderRadius: "5px" }}
            className="badge-light-primary btn-mail d-flex p-2 align-items-center"
          >
            <Plus className="me-2" />
            Add Block
          </button>
        </div>
      </div>
      <BlockTable refetch={refetch} />
    </>
  );
}

export default Block;
